import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logo from '../../../img/logo.png';

const generateVehicleReport = (vehicleData, selectedFields, formatCurrency, formatKilometer, formatDate) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageHeight = doc.internal.pageSize.getHeight();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  let yOffset = margin;

  // ... (código do cabeçalho do PDF permanece o mesmo) ...
    doc.setFont('helvetica');

    const headerSectionHeight = 50;
    const mainGreenBarHeight = 8;
    const lightGreenBarHeight = 2;
    const greenColor = [68, 222, 128];
    const lightGreenColor = [212, 237, 218];
    const headerTextColor = [52, 58, 64];
    const subHeaderTextColor = [108, 117, 125];

    const logoWidth = 50;
    const logoHeight = 30;

    doc.setFillColor(248, 249, 250);
    doc.rect(0, 0, pageWidth, yOffset + headerSectionHeight, 'F');

    doc.setFillColor(greenColor[0], greenColor[1], greenColor[2]);
    doc.rect(0, 0, pageWidth, mainGreenBarHeight, 'F');

    doc.setFillColor(lightGreenColor[0], lightGreenColor[1], lightGreenColor[2]);
    doc.rect(0, mainGreenBarHeight, pageWidth, lightGreenBarHeight, 'F');

    const logoX = margin;
    const logoY = mainGreenBarHeight + lightGreenBarHeight + 6;

    if (logo) {
        doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
    }

    const titleX = logoX + logoWidth + 10;
    const titleY = logoY + 8;
    doc.setFontSize(26);
    doc.setTextColor(headerTextColor[0], headerTextColor[1], headerTextColor[2]);
    doc.setFont('helvetica', 'bold');
    doc.text('RELATÓRIO DE VEÍCULO', titleX, titleY);

    doc.setFontSize(14);
    doc.setTextColor(subHeaderTextColor[0], subHeaderTextColor[1], subHeaderTextColor[2]);
    doc.setFont('helvetica', 'normal');
    doc.text(`${vehicleData.marca} ${vehicleData.modelo} (${vehicleData.placa})`, titleX, titleY + 7);

    doc.setDrawColor(222, 226, 230);
    doc.setLineWidth(0.2);
    doc.line(margin, logoY + logoHeight + 5, pageWidth - margin, logoY + logoHeight + 5);

    yOffset = logoY + logoHeight + 15;

    doc.setFontSize(12);
    doc.setTextColor(headerTextColor[0], headerTextColor[1], headerTextColor[2]);
    doc.setFont('helvetica', 'bold');
    doc.text('Detalhes do Veículo', margin, yOffset - 5);

  // Mapeamento de chaves para labels e formatadores
  const fieldConfig = {
    tipoVeiculo: { label: 'Tipo de Veículo:', value: vehicleData.tipoVeiculo },
    marca: { label: 'Marca:', value: vehicleData.marca },
    modelo: { label: 'Modelo:', value: vehicleData.modelo },
    anoFabricacao: { label: 'Ano Fabricação:', value: vehicleData.anoFabricacao },
    anoModelo: { label: 'Ano Modelo:', value: vehicleData.anoModelo },
    placa: { label: 'Placa:', value: vehicleData.placa },
    renavam: { label: 'RENAVAM:', value: vehicleData.renavam },
    chassi: { label: 'Chassi:', value: vehicleData.chassi },
    cor: { label: 'Cor:', value: vehicleData.cor },
    potenciaMotor: { label: 'Potência do Motor:', value: vehicleData.potenciaMotor },
    motorista_nome: { label: 'Motorista:', value: vehicleData.motorista_nome },
    motorista_cnh: { label: 'Nº Habilitação (CNH):', value: vehicleData.motorista_cnh || 'Não informada' },
    quilometragem: { label: 'Quilometragem:', value: formatKilometer(vehicleData.quilometragem) },
    tipoCombustivel: { label: 'Combustível:', value: vehicleData.tipoCombustivel },
    capacidadeTanque: { label: 'Capacidade do Tanque:', value: `${vehicleData.capacidadeTanque} L` },
    dataAquisicao: { label: 'Data de Aquisição:', value: formatDate(vehicleData.dataAquisicao) },
    valorAquisicao: { label: 'Valor de Aquisição:', value: formatCurrency(vehicleData.valorAquisicao) },
    codigo_cc: { label: 'Código CC:', value: vehicleData.codigo_cc },
    observacoes: { label: 'Observações:', value: vehicleData.observacoes, isBlock: true }
  };

  const tableData = [];
  selectedFields.forEach(key => {
    // Adiciona o campo se ele existir na configuração e não for um bloco de observações
    if (fieldConfig[key] && !fieldConfig[key].isBlock) {
      tableData.push([fieldConfig[key].label, fieldConfig[key].value]);
    }
  });

  doc.autoTable({
    startY: yOffset,
    head: [['Detalhe', 'Valor']],
    body: tableData,
    theme: 'striped',
    styles: {
        font: 'helvetica',
        fontSize: 10,
        cellPadding: 4,
        textColor: [52, 58, 64],
        lineColor: [243, 244, 246],
        lineWidth: 0.1,
        valign: 'middle'
    },
    headStyles: {
        fillColor: [233, 236, 239],
        textColor: [73, 80, 87],
        fontStyle: 'bold',
        halign: 'left',
        fontSize: 11,
        cellPadding: 4,
    },
    columnStyles: {
        0: { fontStyle: 'bold', cellWidth: 55 },
        1: { cellWidth: 'auto' }
    },
    margin: { top: 5, right: margin, bottom: 0, left: margin },
    didDrawPage: function(data) {
        doc.setFontSize(8);
        doc.setTextColor(108, 117, 125);
        const footerY = pageHeight - 10;
        doc.text(`Página ${data.pageNumber}`, pageWidth - margin, footerY, { align: 'right' });
        doc.text(`Gerado em: ${new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`, margin, footerY, { align: 'left' });
    }
  });

  yOffset = doc.autoTable.previous.finalY;

  // Adiciona o bloco de observações se selecionado
  if (selectedFields.includes('observacoes') && vehicleData.observacoes) {
    if (yOffset + 40 > pageHeight - margin) {
      doc.addPage();
      yOffset = margin;
    } else {
      yOffset += 20;
    }
    doc.setFontSize(14);
    doc.setTextColor(52, 58, 64);
    doc.setFont('helvetica', 'bold');
    doc.text('Observações:', margin, yOffset);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(vehicleData.observacoes, margin, yOffset + 10, {
      maxWidth: pageWidth - (margin * 2),
      lineHeightFactor: 1.5
    });
  }

  const now = new Date();
  const formattedDateTime = now.toLocaleString('pt-BR', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      timeZone: 'America/Sao_Paulo'
  }).replace(/[\/, :]/g, '_');

  doc.save(`Relatorio_Veiculo_${vehicleData.placa.replace(/-/g, '_')}_${formattedDateTime}.pdf`);
};

export default generateVehicleReport;
